import _extends from "@babel/runtime/helpers/extends";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/* eslint-disable import/order */
import React, { Component } from 'react';
import { defaultMemoize } from 'reselect';
import PropTypes from 'prop-types';
import _size from 'lodash/size';
import _noop from 'lodash/noop';

// Constants
import { EMPTY_ARRAY, EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';

// Helpers
import { getTableManagerProps, getSubHeaderProps } from './withSelectionSummary.helper';
var withSelectionSummary = function withSelectionSummary(TableManager) {
  var WithSelectionSummary = /*#__PURE__*/function (_Component) {
    _inherits(WithSelectionSummary, _Component);
    var _super = _createSuper(WithSelectionSummary);
    function WithSelectionSummary() {
      var _this;
      _classCallCheck(this, WithSelectionSummary);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _defineProperty(_assertThisInitialized(_this), "getTableManagerProps", defaultMemoize(getTableManagerProps));
      _defineProperty(_assertThisInitialized(_this), "getSubHeaderProps", defaultMemoize(getSubHeaderProps));
      _defineProperty(_assertThisInitialized(_this), "render", function () {
        var _this$props = _this.props,
          selection = _this$props.selection,
          subHeaderProps = _this$props.subHeaderProps,
          tableManagerProps = _this$props.tableManagerProps,
          getSubHeaderPropsForSelection = _this$props.getSubHeaderPropsForSelection;
        var updatedTableManagerProps = _size(selection) ? _this.getTableManagerProps(tableManagerProps, selection) : tableManagerProps;
        var updatedSubHeaderProps = _size(selection) ? _this.getSubHeaderProps(subHeaderProps, selection, getSubHeaderPropsForSelection) : subHeaderProps;
        return /*#__PURE__*/React.createElement(TableManager, _extends({}, _this.props, {
          tableManagerProps: updatedTableManagerProps,
          subHeaderProps: updatedSubHeaderProps
        }));
      });
      return _this;
    }
    return _createClass(WithSelectionSummary);
  }(Component);
  WithSelectionSummary.propTypes = {
    selection: PropTypes.array,
    subHeaderProps: PropTypes.object,
    tableManagerProps: PropTypes.object,
    getSubHeaderPropsForSelection: PropTypes.func
  };
  WithSelectionSummary.defaultProps = {
    selection: EMPTY_ARRAY,
    subHeaderProps: EMPTY_OBJECT,
    tableManagerProps: EMPTY_OBJECT,
    getSubHeaderPropsForSelection: _noop
  };
  return WithSelectionSummary;
};
export default withSelectionSummary;